import { FC, useState } from "react";
import { gameState } from "@/services/gameState";
import { GameProgress } from "@/models/gameState";
import { Box, IconButton } from "@mui/material";
import YoutubeInput from "./YoutubeInput";
import { Groups, Settings, YouTube } from "@mui/icons-material";
import PlayerLists from "@components/dialogs/PlayerLists";
import { useAppDataContext } from "@context/AppContext";

const RefereeTabletFunctionsBar: FC = () => {
  const gameProgress = gameState("gameProgress");
  const { openSettingsDialog } = useAppDataContext();

  const [youtubeInputOpen, setYoutubeInputOpen] = useState(false);
  const [playerListOpen, setPlayerListOpen] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pb: 2,
        gap: 4,
      }}
    >
      <PlayerLists
        open={playerListOpen}
        onClose={() => setPlayerListOpen(false)}
      />
      <IconButton onClick={() => setPlayerListOpen(true)}>
        <Groups />
      </IconButton>
      <IconButton onClick={openSettingsDialog}>
        <Settings />
      </IconButton>
      {gameProgress > GameProgress.GAME_FINISHED && (
        <>
          <YoutubeInput
            open={youtubeInputOpen}
            onClose={() => setYoutubeInputOpen(false)}
          />

          <IconButton onClick={() => setYoutubeInputOpen(true)}>
            <YouTube sx={{ color: "#ed0135" }} />
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default RefereeTabletFunctionsBar;
